//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import { setPreciseAmount } from './ReportMaterialsHelperFunctions.js'
import { createFieldConfig, Store } from '../../../components/QSelectUtils.js'
import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    record: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    operation: {
      type: String,
      default: null
    },
    // ====================
    consumptions: {
      type: Array,
      default () {
        return []
      }
    },
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      consumption: null,

      editedMaterial: null,
      toolFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getTools,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 1
      })),
      units: [
        'шт',
        'упак',
        'пар',
        'компл',
        'м',
        'кг',
        'бут',
        'лист',
        'л',
        'м2',
        'м3',
        'рул',
        'мешок',
        'т',
        'гКал'
      ],
      setPreciseAmount: setPreciseAmount,

      optionsConsumptionDf: [
        {
          label: 'Да',
          value: true
        },
        {
          label: 'Нет',
          value: false
        },
        {
          label: 'Не выбрано',
          value: null
        }
      ]
    }
  },
  computed: {
    showWarningMessageRewriteMounting: function () {
      if (this.consumption && this.consumption.mountingId && this.consumption.toolKey) {
        const mounting = this.mountings.find(mounting => mounting.recId === this.consumption.mountingId)
        return !!mounting && mounting.toolKey !== this.consumption.toolKey
      } else {
        return false
      }
    },
    disabledButtonSave: function () {
      return !(this.reportActionsAccess.editMaterials &&
            (this.consumption.toolName && (this.consumption.toolName !== '' || this.consumption.toolName.trim().length > 0) &&
            (this.consumption.amount && this.consumption.amount !== '' && this.consumption.amount > 0) &&
            (this.consumption.unit && this.consumption.unit !== ''))) ||
            (this.consumption.hasLoops && (this.consumption.loops === '' || this.consumption.loops == null || this.consumption.loops < 0))
    },
    additionalFieldsActive: function () {
      return this.report.isFieldIncluded('mountingsAndDemountings')
    }
  },
  created: function () {
    const consumption = {
      toolKey: null,
      toolName: null,
      projectName: null,
      projectKey: null,
      amount: null,
      unit: null,
      loops: null,
      hasLoops: false,
      sn: null,
      df: null,
      tag: null,
      comment: null,
      mountingId: null,
      demountingId: null,
      isSegment: false
    }

    if (this.isEdit) {
      const editedConsumption = this.record

      this.consumption = consumption
      this.consumption.toolKey = editedConsumption.toolKey
      this.consumption.toolName = editedConsumption.toolName
      this.consumption.projectName = editedConsumption.projectName
      this.consumption.projectKey = editedConsumption.projectKey
      this.consumption.amount = editedConsumption.amount
      this.consumption.unit = editedConsumption.unit
      this.consumption.noted = editedConsumption.noted
      this.consumption.hasLoops = !!editedConsumption.hasLoops
      this.consumption.loops = editedConsumption.loops
      this.consumption.note = editedConsumption.note
      this.consumption.recId = editedConsumption.recId
      this.consumption.sn = editedConsumption.sn
      this.consumption.df = editedConsumption.df
      this.consumption.tag = editedConsumption.tag
      this.consumption.comment = editedConsumption.comment
      this.consumption.mountingId = editedConsumption.mountingId
      this.consumption.demountingId = editedConsumption.demountingId
      this.consumption.isSegment = editedConsumption.isSegment

      this.editedMaterial = {
        id: editedConsumption.toolKey,
        name: editedConsumption.toolName
      }
    } else {
      this.consumption = consumption

      if (this.consumptions && this.consumptions.length) {
        const lastConsumption = this.consumptions[this.consumptions.length - 1]
        this.consumption.projectKey = lastConsumption.projectKey
        this.consumption.projectName = lastConsumption.projectName
      } else {
        this.consumption.projectKey = this.projects[0].projectKey
        this.consumption.projectName = this.projects[0].projectName
      }
    }
  },
  methods: {
    onAddConsumption: function (operation, demountingId) {
      // TODO
    },
    onEditConsumption: function (row) {
      // TODO
    },
    getTools: function (text = '') {
      const urlName = '/service/delta/obj/toolsLoops/search?tree=dictTools&limit=100&pattern=' + text
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          if (response.data && response.data.length) {
            response.data.map(material => {
              material.id = material.key
              material.hasLoops = !!material.hasLoop
              return material
            })
            return response.data
          }
          return text.replace(/\s+/g, '') !== '' ? [{ id: text, name: text }] : []
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка загрузки списка материалов',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки списка материалов'))
        }
      })
    },
    onSetTool: function (tool) {
      if (tool) {
        if (tool.id === tool.name) {
          this.consumption.toolKey = null
        } else {
          this.consumption.toolKey = tool.id
        }
        this.consumption.toolName = tool.name

        this.consumption.hasLoops = tool.hasLoops
        this.consumption.loops = null
      } else {
        this.consumption.toolKey = null
        this.consumption.toolName = null
      }
    },
    onSelectedProject: function (projectKey) {
      if (projectKey) {
        this.consumption.projectKey = projectKey
        this.consumption.projectName = this.projects.find(item => item.projectKey == projectKey).projectName
      } else {
        this.consumption.projectKey = null
        this.consumption.projectName = null
      }
    },
    onSaveConsumption: function () {
      this.$emit('save', this.consumption)
      this.resetConsumption()
    },
    onCloseConsumption: function () {
      this.$emit('close')
      this.resetConsumption()
    },
    resetConsumption: function () {
      this.consumption.toolKey = null
      this.consumption.toolName = null
      this.consumption.projectName = null
      this.consumption.projectKey = null
      this.consumption.amount = null
      this.consumption.unit = null
      this.consumption.hasLoops = false
      this.consumption.loops = null
      this.consumption.sn = null
      this.consumption.df = null
      this.consumption.tag = null
      this.consumption.comment = null
      this.consumption.recId = null
      this.consumption.mountingId = null
      this.consumption.demountingId = null
      this.consumption.isSegment = false

      this.editedMaterial = null
    }
  }
}

